import { render, staticRenderFns } from "./ro-head.vue?vue&type=template&id=208108fd&scoped=true&"
import script from "./ro-head.vue?vue&type=script&lang=js&"
export * from "./ro-head.vue?vue&type=script&lang=js&"
import style0 from "./ro-head.vue?vue&type=style&index=0&id=208108fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208108fd",
  null
  
)

export default component.exports